import { Dict } from "@/types/generalTypes";
import { numberFormatter } from "./numberFormat";

const numberChars = "0,1,2,3,4,5,6,7,8,9,.,-".split(",");

type CaretInfo = {
  n: string;
  pos: number;
  start: number;
};

function grabCaretPosition(
  inputField: HTMLInputElement,
  tempValue: string
): CaretInfo {
  const caretPosition = inputField.selectionStart || 0;
  let n = "";
  let nCount = 0;
  if (caretPosition && caretPosition > 0) {
    for (let i = caretPosition - 1; i >= 0; i--) {
      const char = tempValue[i];
      if (numberChars.includes(char)) {
        if (n === "") {
          n = char;
          nCount = 1;
        } else if (char === n) {
          nCount++;
        }
      }
    }
  }
  return { n, pos: nCount, start: caretPosition };
}

function getNewCaretPosition(
  formated: string,
  caretInfo: CaretInfo
): number {
  let nPos = 0;
  if (caretInfo.n === "") {
    for (let i = 0; i < formated.length; i++) {
      if (numberChars.includes(formated[i])) {
        nPos = i;
        break;
      }
    }
  } else {
    let tc = 0;
    for (let i = 0; i < formated.length; i++) {
      if (numberChars.includes(formated[i])) {
        nPos = i + 1;
      }
      if (formated[i] === caretInfo.n) {
        tc++;
        if (tc >= caretInfo.pos) {
          break;
        }
      }
    }
  }
  return nPos;
}

function reposCaret(inputField: HTMLInputElement, newCaretPos: number) {
  inputField.selectionStart = newCaretPos;
  inputField.selectionEnd = newCaretPos;
}

export default function (
  inputField: HTMLInputElement,
  format: Dict<any> | null | undefined,
  onUpdate: (value: string, varName: string) => void,
) {
  let timer: number | null = null;
  const formatter = format ? numberFormatter(format) : null;
  const varName = inputField.dataset.answerName ? inputField.dataset.answerName : '';
  if(!format?.isString){
    inputField.setAttribute('inputmode', 'numeric');
  }

  const refreshValue = (value: string | null = null, force = false) => {
    if (!formatter) {
      onUpdate(value || '', varName);
      return;
    }
    const tempValue = value || inputField.value;
    if (!tempValue) {
      return;
    }
    const caretInfo = grabCaretPosition(inputField, tempValue);
    if(!force) {
      if (caretInfo.n == "." || caretInfo.n == "-") {
        return;
      }
      if(caretInfo.n == '0') {
        const left = tempValue.slice(0, caretInfo.start);
        if(left.indexOf('.') > -1) {
          return;
        }
      }
    }
    const newV = formatter.parse(tempValue);
    const newFormated = isNaN(newV) ? "" : formatter.format(newV);
    const unformated = isNaN(newV) ? "" : newV + "";
    const newCPos = getNewCaretPosition(newFormated, caretInfo);

    inputField.value = newFormated;
    reposCaret(inputField, newCPos);
    onUpdate(unformated, varName);
  };

  const handleInput = () => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(refreshValue, 200);
  };
  const handleChange = () => {
    refreshValue(inputField.value, true);
  }

  inputField.addEventListener("input", handleInput);
  inputField.addEventListener("change", handleChange);

  refreshValue(inputField.value);

  return {
    update(value: string) {
      if(!formatter) {
        return;
      }
      if(formatter.parse(inputField.value) != formatter.parse(value)) {
        refreshValue(value);
      }
    },
    destroy() {
      inputField.removeEventListener("input", handleInput);
      if (timer) {
        clearTimeout(timer);
      }
    },
  };
}
